import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { AppConfig } from '../../../app.config';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class WidgetPreferencesService {

  widgetPreferenceUpdated = new Map();

  widgetPreferenceData = new Map();

  constructor(private authHttp: AuthHttp, private appConfig: AppConfig) {
  }

  getAllWidgetPreferences() {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.get(serverUrl + 'widgetpreference/all').toPromise().then((response: any) => {
      const widgets = JSON.parse(response._body);
      return widgets;
    });
  }

  updateFavouriteWidgetPreference(endPoint, value, id) {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.post(serverUrl + 'widgetpreference/favourite/' +  endPoint.toLowerCase(), { model :  {value, id} }).toPromise().then((response: any) => {
      const widgetPreferences = this.getWidgetPreferencesByName(endPoint);
      widgetPreferences.favourite = value;
      this.updateSubject(endPoint, widgetPreferences);
    });
  }

  updateArchiveWidgetPreference(endPoint, value, id) {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.post(serverUrl + 'widgetpreference/archive/' +  endPoint.toLowerCase(), { model :  {value, id} }).toPromise().then((response: any) => {
      const widgetPreferences = this.getWidgetPreferencesByName(endPoint);
      widgetPreferences.archive = value;
      this.updateSubject(endPoint, widgetPreferences);
    });
  }

  updateDataWidgetPreference(endPoint, value, id) {
    let widgetPreferences = this.getWidgetPreferencesByName(endPoint);
    widgetPreferences.interactedWith = value;
    this.updateSubject(endPoint, widgetPreferences);

    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.post(serverUrl + 'widgetpreference/data/' +  endPoint.toLowerCase(), { model :  {value, id} }).toPromise().then((response: any) => {
    }).catch(() => {
      widgetPreferences = this.getWidgetPreferencesByName(endPoint);
      widgetPreferences.interactedWith = !value;
      this.updateSubject(endPoint, widgetPreferences);
    });
  }

  createSubject(widgetName) {
    this.widgetPreferenceUpdated.set(widgetName, new Subject());
  }

  subscribeSubject(widgetName) {
    return this.widgetPreferenceUpdated.get(widgetName);
  }

  updateSubject(widgetName, value) {
    this.widgetPreferenceData.set(widgetName, value);
    this.widgetPreferenceUpdated.get(widgetName).next(value);
  }

  getWidgetPreferencesByName(widgetName) {
    return this.widgetPreferenceData.get(widgetName);
  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/services/widget-preferences.service.ts